import type { ListItemProps, ListProps } from '@qbe/ads-core';
import { List, ListItem } from '@qbe/ads-core';
import * as React from 'react';

export interface UnorderedListProps extends ListProps {
  children?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sx?: any; // TODO
}

export interface UnorderedListItemProps extends ListItemProps {
  children?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sx?: any; // TODO
}

export const UnorderedList: React.FC<UnorderedListProps> = ({ children, sx = {}, ...props }) => (
  <List sx={{ listStyleType: 'disc', listStylePosition: 'inside', ...sx }} {...props}>
    {children}
  </List>
);

export const UnorderedListItem: React.FC<UnorderedListItemProps> = ({ children, sx, ...props }) => (
  <ListItem sx={{ display: 'list-item', paddingTop: 0, ...sx }} {...props}>
    {children}
  </ListItem>
);
